module.exports = __webpack_public_path__ + "img/MarketSizePieChart.cbd59c4b.png";